import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import WidgetSettings from "./widgetsettings"
import { selectionTypes } from '../../utils/consts';
import { seconds2HMS } from '../../utils/utils';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {
    DataGrid, Column, ColumnChooser, Paging, Sorting, SearchPanel, Scrolling
} from 'devextreme-react/data-grid';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from "devextreme/data/array_store";
import MonitorService from '../../../controllers/MonitorService';
import ChatsService from 'src/controllers/ChatController';
import InteractionMailModal from 'src/components/misc/interactionMailModal';
import InteractionMessagesModal from 'src/components/misc/interactionmessagesmodal';
import ViewChatCellRenderer from './queuedchats/viewchatcellrenderer';
import TransferButtonRenderer from './queuedchats/transferbuttonrenderer';
import ChannelIconRenderer from './queuedchats/channeliconrenderer';

class QueuedChats extends Component {

    constructor(props) {
        super(props);
        let selectedGroups = localStorage.getItem(`QueuedChats_groups_${this.props.userId}`);
        this.dataGridRef = React.createRef();
        this.store = new ArrayStore({
            key: "guid",
            data: []
        });

        this.dataSource = new DataSource({
            store: this.store,
            reshapeOnPush: true
        });
        this.lastUpdate = new Date();
        this.lastUpdate.setMinutes(this.lastUpdate.getMinutes() - 1);
        this.state = {
            showSettings: false,
            selectedGroups: selectedGroups ? JSON.parse(selectedGroups) : [],
            queuedChats: 0,
            showInteraction: false,
            interaction: null,
            showInteractionMail: false,
            emailMessageNumber: null,
            iframeUrl: '',
            channel: localStorage.getItem(`QueuedChats_channel_${this.props.userId}`) || "",
            channelName: localStorage.getItem(`QueuedChats_channelName_${this.props.userId}`) || ""
        };

        this.updateState = this.updateState.bind(this);
        this.selectGroups = this.selectGroups.bind(this);
        this.toggleSettings = this.toggleSettings.bind(this);
        this.toggleInteraction = this.toggleInteraction.bind(this);
        this.interactionClick = this.interactionClick.bind(this);
        this.toggleInteractionMail = this.toggleInteractionMail.bind(this);

        this.setGroupsAndChannel = this.setGroupsAndChannel.bind(this);
        this.renderViewChatCell = (cellInfo) => (
            <ViewChatCellRenderer
                key={cellInfo.data.guid}
                data={cellInfo.data}
                onClickHandler={this.interactionClick}
                t={this.props.t}
            />
        );

        this.renderTransferButton = (cellInfo) => (
            <TransferButtonRenderer
                key={cellInfo.data.guid}
                data={cellInfo.data}
                userId={this.props.userId}
                token={this.props.token}
            />
        );

        this.renderChannelIcon = (cellInfo) => (
            <ChannelIconRenderer key={cellInfo.data.guid} value={cellInfo.value} />
        );
    }

    toggleSettings() {
        this.setState({
            showSettings: !this.state.showSettings
        });
    }

    selectGroups(groups) {
        this.setState({
            groups: groups,
            showSettings: !this.state.showSettings
        });

        localStorage.setItem(`QueuedChats_groups_${this.props.userId}`, JSON.stringify(groups));
        if (MonitorService?.stompClient?.connected) {
            MonitorService.stompClient.send("/app/subscribe/queuedchats", {}, JSON.stringify({
                token: this.props.token,
                groupsIds: groups
            }));
        }

    }
    setGroupsAndChannel(groups, channel, channelName) {
        this.setState({
            groups: groups,
            showSettings: !this.state.showSettings,
            channel: channel,
            channelName: channelName
        });

        localStorage.setItem(`QueuedChats_groups_${this.props.userId}`, JSON.stringify(groups));
        localStorage.setItem(`QueuedChats_channel_${this.props.userId}`, channel);
        localStorage.setItem(`QueuedChats_channelName_${this.props.userId}`, channelName);

        if (MonitorService?.stompClient?.connected) {
            MonitorService.stompClient.send("/app/subscribe/queuedchats", {}, JSON.stringify({
                token: this.props.token,
                groupsIds: groups
            }));
        }

    }

    updateState(chats) {
        let lastUpdateDiff = (new Date() - this.lastUpdate);
        if (lastUpdateDiff > 1000) {
            var data = JSON.parse(chats.body);
            var chn = localStorage.getItem(`QueuedChats_channel_${this.props.userId}`);

            if (chn !== null && chn !== "")
                data = data.filter(x => x.channel.toLowerCase() === chn.toLowerCase());

            data.forEach(v => {
                var queueDate = new Date();
                queueDate.setSeconds(queueDate.getSeconds() - v.timeWaiting);
                queueDate.setMilliseconds(1);
                var diff = v.timeWaiting;
                v.queueDate = queueDate;

                v.waitingTime = seconds2HMS(diff);
            });

            let callIds = this.dataSource.items().map(x => x.guid);

            const changes = [];
            callIds.forEach(x => {
                if (data.map(c => c.guid).indexOf(x) === -1) {
                    changes.push({ type: 'remove', key: x });
                }

            });

            data.forEach(v => {
                if (callIds.indexOf(v.guid) > -1) {
                    changes.push({ type: 'update', key: v.guid, data: v });
                } else {
                    changes.push({ type: 'insert', key: v.guid, data: v });
                }

            });

            if (changes.length)
                this.dataSource.store().push(changes);

            this.lastUpdate = new Date();

            this.setState({
                queuedChats: data.length
            });

        }
    }

    componentDidMount() {

        let selectedGroups = JSON.parse(localStorage.getItem(`QueuedChats_groups_${this.props.userId}`) || "[]");
        this.setState({
            selectedGroups: selectedGroups,
        });

        if (MonitorService?.stompClient?.connected) {
            MonitorService.stompClient.send("/app/subscribe/queuedchats", {}, JSON.stringify({
                token: this.props.token,
                groupsIds: selectedGroups
            }));

            MonitorService.stompClient.subscribe(`/user/${this.props.token}/topic/queuedchats/`, this.updateState, { id: "queuedchats" });
        }

    }

    componentWillUnmount() {

        if (this.dataSource?.dispose) {
            this.dataSource.dispose();
        }
        if (this.store?.clear) {
            this.store.clear();
        }
        if (this.dataGridRef.current && this.dataGridRef.current.instance) {
            this.dataGridRef.current.instance.dispose();

        }

        if (MonitorService?.stompClient?.connected) {
            MonitorService.stompClient.send("/app/unsubscribe/queuedchats", {}, JSON.stringify({
                token: this.props.token,
            }));

            MonitorService.stompClient.unsubscribe("queuedchats");
        }
    }
    toggleInteractionMail = e => {
        this.setState({ showInteractionMail: !this.state.showInteractionMail });

    }


    toggleInteraction = e => {
        this.setState({ showInteraction: !this.state.showInteraction });
    }

    interactionClick = (chatGuid) => {

        ChatsService.getChatByGuid(chatGuid, res => {
            if (res.data) {
                if (res.data.type.toLowerCase() === "mail") {
                    var emailMessageNumber = res.data.messages[0].messageId
                    var inbox = res.data.messages[0].inbox
                    var data = JSON.parse(localStorage.getItem("fc-logged"));
                    var rcu = localStorage.getItem("faRCUser");
                    var rcp = localStorage.getItem("faRCPwd");
                    var roundcubeUrl = localStorage.getItem("faRC");

                    var url = `${roundcubeUrl}?user=${rcu}&pass=${rcp}&tenant=${data.tenantName}&agentId${this.props.userId}&_task=mail&_action=show&_uid=${emailMessageNumber}&_mbox=${inbox}&_fainbox=1`
                    res.data.channel = res.data.type;

                    this.setState({
                        emailMessageNumber: emailMessageNumber,
                        iframeUrl: url,
                        showInteractionMail: true,
                        interaction: res.data
                    });

                } else {
                    res.data.channel = res.data.type;
                    this.setState({
                        showInteraction: true,
                        interaction: res.data
                    });

                }
            }
        });
    }

    render() {

        return (
            <div className='position-relative' style={{ top: 10 }}>
                <div className={"card card-flush overflow-hidden h-lg-20 widget-container"} style={{ width: "100%", height: "100%", margin: "0px" }}>
                    <div className="card-header drag-handle">
                        <h3 className="card-title align-items-start flex-column text-primary">
                            <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("message-plus")} /> {this.props.t("queuedchats")}<span className="badge badge-light-primary fs-base">{this.state.queuedChats}</span></span>
                        </h3>
                        <div className="card-toolbar" style={{ zIndex: 1000 }}>
                            <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={<Tooltip style={{ position: "fixed" }}>
                                    {this.props.t("config")}
                                </Tooltip>}>
                                <button type="button" className="btn btn-sm btn-icon btn-color-primary btn-active-light-primary" onClick={this.toggleSettings} >
                                    <FontAwesomeIcon icon={duotone("grid-2")} />
                                </button>
                            </OverlayTrigger>
                        </div>
                    </div>
                    <div className="card-body" style={{ padding: "0px", height: "465px" }} >

                        <DataGrid
                            id="queuedchatstable"
                            ref={this.dataGridRef}
                            dataSource={this.dataSource}
                            keyExpr="guid"
                            showBorders={false}
                            repaintChangesOnly={true}
                            columnAutoWidth={true}
                            width={"100%"}
                            height={"99%"}
                            allowColumnResizing={true}
                            rowAlternationEnabled={true}
                            loadPanel={{ enabled: false }}  >
                            <SearchPanel
                                visible={true}
                                width={240}
                                placeholder={this.props.t("search")}
                            />
                            <Sorting mode={"single"} />
                            <Scrolling mode={"standard"} />
                            <Paging defaultPageSize={7} />
                            <Column dataField="id" visible={false} showInColumnChooser={false} />
                            <Column cssClass={"align-middle"} visible={this.props.functions.manageInteractions} dataField="transfer" caption={""} showInColumnChooser={false} width={45} cellRender={this.renderTransferButton} />
                            <Column dataField="channel" caption={this.props.t("channel")} width={45} cellRender={this.renderChannelIcon} alignment="center" />
                            <Column cssClass={"align-middle"} dataField="text" caption={this.props.t("message")} visible={true} width={120} />
                            <Column cssClass={"align-middle"} dataField="queueDate" caption={this.props.t("hour")} dataType={"datetime"} format={"HH:mm:ss"} visible={true} width={75} />
                            <Column cssClass={"align-middle"} dataField="from" caption={this.props.t("from")} visible={true} width={100} />
                            <Column cssClass={"align-middle"} dataField="groupName" caption={this.props.t("group")} visible={true} width={100} />
                            <Column cssClass={"align-middle"} dataField="waitingTime" caption={this.props.t("waitingtime")} visible={true} width={75} sortOrder={"asc"} />
                            <Column cssClass={"align-middle"} dataField="chatGuid" caption={""} width={45} cellRender={this.renderViewChatCell} allowFiltering={false} />
                            <ColumnChooser enabled={false} mode={"select"} allowSearch={true} />
                        </DataGrid>
                    </div>

                </div>
                <WidgetSettings showSettings={this.state.showSettings} toggleSettings={this.toggleSettings} token={this.props.token} setGroupsAndChannel={this.setGroupsAndChannel} groups={this.state.selectedGroups} selectionType={selectionTypes.MESSAGESQUEUE}></WidgetSettings>
                <InteractionMailModal show={this.state.showInteractionMail} toggleModal={this.toggleInteractionMail} interaction={this.state.interaction} url={this.state.iframeUrl}></InteractionMailModal>
                <InteractionMessagesModal show={this.state.showInteraction} toggleModal={this.toggleInteraction} interaction={this.state.interaction}></InteractionMessagesModal>

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.agent.monitorToken,
        userId: state.agent.userId,
        functions: state.agent.functions,
    };
};
export default compose(connect(mapStateToProps, null), withTranslation())(QueuedChats);